(function () {
  'use strict';

  var ann, header, annHeight;

  function headerH() {
    return header ? (header.getBoundingClientRect().height || 60) : 60;
  }

  function getAnnHeight() {
    return ann ? (ann.getBoundingClientRect().height || 0) : 0;
  }

  function setPageTopOffset() {
    if (!header) return;

    var h = headerH();
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var visibleAnnHeight = 0;

    if (ann && annHeight > 0) {
      if (!ann.classList.contains('is-hidden')) {
        visibleAnnHeight = Math.max(annHeight - y, 0);
      }
    }

    document.documentElement.style.setProperty(
      '--custom-top-offset',
      (h + visibleAnnHeight) + 'px'
    );
  }

  function syncMegaTop() {
    if (!header) return;

    var headerTop = parseInt(header.style.top || '0', 10) || 0;
    var top = headerTop + headerH();

    document.querySelectorAll('.custom-mega-menu').forEach(function (m) {
      m.style.top = top + 'px';
    });
  }

  function syncSearchTop() {
    if (!header) return;

    var bar = document.getElementById('custom-search-bar');
    if (!bar) return;

    var headerTop = parseInt(header.style.top || '0', 10) || 0;
    bar.style.top = (headerTop + headerH()) + 'px';
  }

  function handleScroll() {
    if (!header) return;

    var y = window.pageYOffset || 0;

    if (ann && annHeight > 0) {
      if (y >= annHeight) {
        ann.classList.add('is-hidden');
        ann.style.top = (-annHeight) + 'px';
        header.style.top = '0px';
      } else {
        ann.classList.remove('is-hidden');
        ann.style.top = (-y) + 'px';
        header.style.top = (annHeight - y) + 'px';
      }
    } else {
      header.style.top = '0px';
    }

    setPageTopOffset();
    syncMegaTop();
    syncSearchTop();
  }

  function initHeaderPosition() {
    ann = document.getElementById('custom-announcement-bar') 
      || document.querySelector('.announcement-bar');
    header = document.getElementById('custom-header-wrapper');

    if (!header) return;

    requestAnimationFrame(function () {
      if (ann) {
        ann.classList.remove('is-hidden');
        ann.style.top = '0px';
        annHeight = getAnnHeight();
      } else {
        annHeight = 0;
      }

      setPageTopOffset();

      header.style.top = annHeight + 'px';

      handleScroll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderPosition);
  } else {
    initHeaderPosition();
  }
  window.addEventListener('load', initHeaderPosition);

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initHeaderPosition, 50);
  });

  window.addEventListener('resize', function () {
    if (!header) return;

    if (ann) {
      ann.classList.remove('is-hidden');
      ann.style.top = '0px';
      annHeight = getAnnHeight();
    } else {
      annHeight = 0;
    }

    setPageTopOffset();
    handleScroll();
  });

  var ticking = false;

  window.addEventListener('scroll', function () {
    if (!header) return;
    if (ticking) return;

    ticking = true;

    requestAnimationFrame(function () {
      handleScroll();
      ticking = false;
    });
  }, { passive: true });

  /* ============================================
     Mega Menu
  ============================================ */
  var megaItems = document.querySelectorAll('.custom-header__item--mega');

  function closeAllMega(except) {
    megaItems.forEach(function (item) {
      if (item === except) return;

      item.classList.remove('is-open');

      var m = item.querySelector('.custom-mega-menu');
      var b = item.querySelector('.custom-header__link--toggle');

      if (m) m.setAttribute('aria-hidden', 'true');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  megaItems.forEach(function (item) {
    var timer;
    var btn = item.querySelector('.custom-header__link--toggle');

    item.addEventListener('mouseenter', function () {
      if (window.innerWidth < 990) return;

      clearTimeout(timer);
      closeAllMega(item);
      item.classList.add('is-open');

      var m = item.querySelector('.custom-mega-menu');
      if (m) m.setAttribute('aria-hidden', 'false');
      if (btn) btn.setAttribute('aria-expanded', 'true');

      syncMegaTop();
    });

    item.addEventListener('mouseleave', function () {
      if (window.innerWidth < 990) return;

      timer = setTimeout(function () {
        item.classList.remove('is-open');

        var m = item.querySelector('.custom-mega-menu');
        if (m) m.setAttribute('aria-hidden', 'true');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }, 120);
    });

    if (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();

        var isOpen = item.classList.contains('is-open');

        closeAllMega();

        if (!isOpen) {
          item.classList.add('is-open');

          var m = item.querySelector('.custom-mega-menu');
          if (m) m.setAttribute('aria-hidden', 'false');

          btn.setAttribute('aria-expanded', 'true');
          syncMegaTop();
        }
      });
    }
  });

  document.addEventListener('click', function () {
    closeAllMega();
  });

  document.querySelectorAll('.custom-mega-menu').forEach(function (m) {
    m.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });

  /* ============================================
     移动端顶部下拉菜单 (Dropdown)
  ============================================ */
  var burger = document.getElementById('custom-burger-btn');

  // 创建下拉菜单容器
  var mobileDrawer = document.createElement('div');
  mobileDrawer.id = 'custom-mobile-drawer';
  mobileDrawer.setAttribute('aria-hidden', 'true');
  mobileDrawer.innerHTML =
    '<div class="custom-drawer__panel">' +
    '  <ul class="custom-drawer__list" id="custom-drawer-list"></ul>' +
    '</div>';

  // 创建独立的背景遮罩层
  var drawerOverlay = document.createElement('div');
  drawerOverlay.className = 'custom-drawer__overlay';
  drawerOverlay.id = 'custom-drawer-overlay';

  // 将它们挂载到页面上
  document.body.appendChild(mobileDrawer);
  document.body.appendChild(drawerOverlay);

  function buildDrawerMenu() {
    var list = document.getElementById('custom-drawer-list');
    if (!list) return;

    list.innerHTML = '';

    document.querySelectorAll('.custom-header__item').forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'custom-drawer__item';

      var megaMenu = item.querySelector('.custom-mega-menu');
      var toggleBtn = item.querySelector('.custom-header__link--toggle');

      if (megaMenu && toggleBtn) {
        var label = toggleBtn.childNodes[0].textContent.trim();

        var acc = document.createElement('button');
        acc.className = 'custom-drawer__acc-btn';
        acc.innerHTML = label + '<svg class="custom-drawer__caret" width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

        var sub = document.createElement('ul');
        sub.className = 'custom-drawer__sub';

        megaMenu.querySelectorAll('.custom-mega-menu__link').forEach(function (a) {
          var subLi = document.createElement('li');
          var subA = document.createElement('a');

          subA.href = a.href;
          subA.textContent = a.textContent.trim();
          subA.className = 'custom-drawer__sub-link';

          subLi.appendChild(subA);
          sub.appendChild(subLi);
        });

        // 绑定手风琴折叠事件
        acc.addEventListener('click', function (e) {
          e.stopPropagation();
          var isOpen = li.classList.contains('is-open');

          // 关闭其他已展开的二级菜单
          list.querySelectorAll('.custom-drawer__item.is-open').forEach(function (el) {
            if (el !== li) {
              el.classList.remove('is-open');
            }
          });

          if (isOpen) {
            li.classList.remove('is-open');
          } else {
            li.classList.add('is-open');
          }
        });

        li.appendChild(acc);
        li.appendChild(sub);
      } else {
        var plainBtn = item.querySelector('.custom-header__link');
        if (!plainBtn) return;

        var a = document.createElement('button');
        a.className = 'custom-drawer__link';
        a.textContent = plainBtn.textContent.trim();

        a.addEventListener('click', function () {
          closeMobileDrawer();
          plainBtn.click();
        });

        li.appendChild(a);
      }

      list.appendChild(li);
    });
  }

  function toggleMobileDrawer() {
    var isOpen = mobileDrawer.classList.contains('is-open');
    if (isOpen) {
      closeMobileDrawer();
    } else {
      openMobileDrawer();
    }
  }

  function openMobileDrawer() {
    buildDrawerMenu();
    
    // 动态同步最新的 Header 顶部偏移量，确保下拉菜单紧贴 Header 底部
    var offset = document.documentElement.style.getPropertyValue('--custom-top-offset') || '60px';
    mobileDrawer.style.top = offset;
    drawerOverlay.style.top = offset;

    mobileDrawer.setAttribute('aria-hidden', 'false');
    mobileDrawer.classList.add('is-open');
    drawerOverlay.classList.add('is-open');
    
    if (burger) {
      burger.setAttribute('aria-expanded', 'true');
    }
  }

  function closeMobileDrawer() {
    mobileDrawer.setAttribute('aria-hidden', 'true');
    mobileDrawer.classList.remove('is-open');
    drawerOverlay.classList.remove('is-open');
    
    if (burger) {
      burger.setAttribute('aria-expanded', 'false');
    }
  }

  // 汉堡按钮点击事件（阻止冒泡，防止触发全局关闭）
  if (burger) {
    burger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleMobileDrawer();
    });
    // 兼容移动端触摸
    burger.addEventListener('touchstart', function (e) {
      e.stopPropagation();
    }, { passive: true });
  }

  // 1. 点击遮罩层（Overlay）时，无条件关闭下拉菜单
  if (drawerOverlay) {
    var handleOverlayClick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeMobileDrawer();
    };
    drawerOverlay.addEventListener('click', handleOverlayClick);
    drawerOverlay.addEventListener('touchstart', handleOverlayClick, { passive: false });
  }

  // 2. 阻止下拉菜单内部的点击/触摸事件向上冒泡到 document，避免触发全局关闭
  mobileDrawer.addEventListener('click', function (e) {
    e.stopPropagation();
  });
  mobileDrawer.addEventListener('touchstart', function (e) {
    e.stopPropagation();
  }, { passive: true });

  // 3. 全局点击/触摸事件：如果用户点击了下拉菜单和汉堡按钮之外的任何空白区域，则关闭菜单
  var handleGlobalOutsideClick = function (e) {
    var isOpen = mobileDrawer.classList.contains('is-open');
    if (!isOpen) return;

    // 确保点击的目标既不在下拉菜单内部，也不在汉堡按钮内部
    if (!mobileDrawer.contains(e.target) && !burger.contains(e.target)) {
      closeMobileDrawer();
    }
  };

  document.addEventListener('click', handleGlobalOutsideClick);
  document.addEventListener('touchstart', handleGlobalOutsideClick, { passive: true });

  /* ============================================
     Give $40 Modal
  ============================================ */
  var giveTrigger = document.getElementById('give-get-trigger');
  var giveModal = document.getElementById('give-modal');
  var giveOverlay = document.getElementById('give-modal-overlay');
  var giveClose = document.getElementById('give-modal-close');
  var giveForm = document.getElementById('give-modal-form');
  var giveSuccess = document.getElementById('give-modal-success');

  function openGiveModal() {
    if (!giveModal) return;

    giveModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeGiveModal() {
    if (!giveModal) return;

    giveModal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (giveTrigger) giveTrigger.addEventListener('click', openGiveModal);
  if (giveOverlay) giveOverlay.addEventListener('click', closeGiveModal);
  if (giveClose) giveClose.addEventListener('click', closeGiveModal);

  if (giveForm) {
    giveForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var email = giveForm.querySelector('[name="email"]').value.trim();
      if (!email) return;

      var firstName = giveForm.querySelector('[name="first_name"]').value.trim();
      var accepts = giveForm.querySelector('[name="accepts_marketing"]').checked;
      var sb = giveForm.querySelector('.give-modal__submit');

      sb.disabled = true;
      sb.textContent = 'Submitting...';

      fetch('/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          'form_type': 'customer',
          'utf8': '✓',
          'contact[first_name]': firstName,
          'contact[email]': email,
          'contact[tags]': 'give-get-referral',
          'contact[accepts_marketing]': accepts ? '1' : '0'
        })
      }).finally(function () {
        giveForm.style.display = 'none';

        if (giveSuccess) {
          giveSuccess.style.display = 'block';
        }
      });
    });
  }

  /* ============================================
     搜索展开栏
  ============================================ */
  var searchTrigger = document.getElementById('custom-search-trigger');
  var searchCloseIcon = document.getElementById('custom-search-close-icon');
  var searchBar = document.getElementById('custom-search-bar');
  var searchInput = document.getElementById('custom-search-input');

  function openSearch() {
    if (!searchBar) return;

    closeAllMega();
    syncSearchTop();

    searchBar.setAttribute('aria-hidden', 'false');
    searchBar.classList.add('is-open');

    if (searchTrigger) searchTrigger.style.display = 'none';
    if (searchCloseIcon) searchCloseIcon.style.display = 'inline-flex';

    setTimeout(function () {
      if (searchInput) searchInput.focus();
    }, 50);
  }

  function closeSearch() {
    if (!searchBar) return;

    searchBar.setAttribute('aria-hidden', 'true');
    searchBar.classList.remove('is-open');

    if (searchTrigger) searchTrigger.style.display = 'inline-flex';
    if (searchCloseIcon) searchCloseIcon.style.display = 'none';
  }

  if (searchTrigger) {
    searchTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      openSearch();
    });
  }

  if (searchCloseIcon) {
    searchCloseIcon.addEventListener('click', function (e) {
      e.stopPropagation();
      closeSearch();
    });
  }

  document.addEventListener('click', function (e) {
    if (!searchBar || !searchBar.classList.contains('is-open')) return;
    if (searchBar.contains(e.target)) return;
    if (searchTrigger && searchTrigger.contains(e.target)) return;
    if (searchCloseIcon && searchCloseIcon.contains(e.target)) return;

    closeSearch();
  });

  /* ============================================
     购物车抽屉
  ============================================ */
  var cartTrigger = document.getElementById('custom-cart-trigger');
  var cartDrawer = document.getElementById('custom-cart-drawer');
  var cartOverlay = document.getElementById('custom-cart-overlay');
  var cartClose = document.getElementById('custom-cart-close');
  var cartBody = document.getElementById('custom-cart-body');
  var cartCountEl = document.getElementById('custom-cart-count');
  var cartRecProducts = window.__cartRecProducts__ || [];

  function openCartDrawer() {
    if (!cartDrawer) return;

    loadCartAndRender();

    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;

    cartDrawer.setAttribute('aria-hidden', 'true');
    cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function updateCartCount(count) {
    if (!cartCountEl) return;

    if (count > 0) {
      cartCountEl.textContent = count;
      cartCountEl.style.display = 'flex';
    } else {
      cartCountEl.style.display = 'none';
    }
  }

  function loadCartAndRender() {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        renderCartBody(cart);
      });
  }

  function updateItemQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: qty
      })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        renderCartBody(cart);
      });
  }

  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        renderCartBody(cart);
      });
  }

  function buildRecHtml() {
    if (!cartRecProducts || cartRecProducts.length === 0) return '';

    var cards = '';

    cartRecProducts.forEach(function (p) {
      cards +=
        '<div class="custom-cart-drawer__rec-card">' +
          (p.image ? '<img src="' + p.image + '" alt="' + p.title + '">' : '<div class="custom-cart-drawer__rec-card-placeholder"></div>') +
          '<div class="custom-cart-drawer__rec-info">' +
            '<p class="custom-cart-drawer__rec-name">' + p.title + '</p>' +
            '<p class="custom-cart-drawer__rec-variant">' + (p.variant || '') + '</p>' +
            '<p class="custom-cart-drawer__rec-price">$' + p.price + '</p>' +
            '<button class="custom-cart-drawer__rec-add" data-variant-id="' + p.variantId + '">Add +</button>' +
          '</div>' +
        '</div>';
    });

    return (
      '<div class="custom-cart-drawer__rec-wrap">' +
        '<button class="custom-cart-drawer__rec-prev" aria-label="Previous"><svg width="8" height="12" viewBox="0 0 8 12" fill="none"><path d="M6 1L1 6L6 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>' +
        '<div class="custom-cart-drawer__rec-track-outer">' +
          '<div class="custom-cart-drawer__rec-track" id="cart-rec-track">' + cards + '</div>' +
        '</div>' +
        '<button class="custom-cart-drawer__rec-next" aria-label="Next"><svg width="8" height="12" viewBox="0 0 8 12" fill="none"><path d="M2 1L7 6L2 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>' +
      '</div>'
    );
  }

  function renderCartBody(cart) {
    if (!cartBody) return;

    var recHtml = buildRecHtml();

    if (cart.item_count === 0) {
      cartBody.innerHTML =
        '<p class="custom-cart-drawer__empty-title">Your cart is empty!<br>Start your wellness journey today.</p>' +
        recHtml +
        '<p class="custom-cart-drawer__rec-footer">Looking for <a href="/collections/all"><em>something else?</em></a></p>' +
        '<a href="/collections/all" class="custom-cart-drawer__shop-all">Shop All <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7H12M8 3L12 7L8 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
    } else {
      var itemsHtml = '<div class="custom-cart-drawer__items">';

      cart.items.forEach(function (item) {
        var linePrice = (item.final_line_price / 100).toFixed(2);

        itemsHtml +=
          '<div class="custom-cart-drawer__item" data-key="' + item.key + '">' +
            '<img class="custom-cart-drawer__item-img" src="' + item.image + '" alt="' + item.product_title + '">' +
            '<div class="custom-cart-drawer__item-info">' +
              '<div class="custom-cart-drawer__item-top">' +
                '<p class="custom-cart-drawer__item-title">' + item.product_title + '</p>' +
                '<button class="custom-cart-drawer__item-remove" data-key="' + item.key + '" aria-label="Remove item">' +
                  '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 2L12 12M12 2L2 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
                '</button>' +
              '</div>' +
              (item.variant_title ? '<p class="custom-cart-drawer__item-variant">' + item.variant_title + '</p>' : '') +
              '<div class="custom-cart-drawer__item-bottom">' +
                '<div class="custom-cart-drawer__qty">' +
                  '<button class="custom-cart-drawer__qty-btn" data-key="' + item.key + '" data-action="minus" aria-label="Decrease quantity">−</button>' +
                  '<span class="custom-cart-drawer__qty-num">' + item.quantity + '</span>' +
                  '<button class="custom-cart-drawer__qty-btn" data-key="' + item.key + '" data-action="plus" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<p class="custom-cart-drawer__item-price">$' + linePrice + '</p>' +
              '</div>' +
            '</div>' +
          '</div>';
      });

      itemsHtml += '</div>';

      var totalPrice = (cart.total_price / 100).toFixed(2);

      var footerHtml =
        '<div class="custom-cart-drawer__footer">' +
          '<div class="custom-cart-drawer__subtotal">' +
            '<span>Subtotal</span>' +
            '<span>$' + totalPrice + '</span>' +
          '</div>' +
          '<a href="/checkout" class="custom-cart-drawer__checkout">Checkout · $' + totalPrice + '</a>' +
        '</div>';

      cartBody.innerHTML = itemsHtml + recHtml + footerHtml;
    }

    bindCartItems();
    bindRecCarousel();
  }

  function bindCartItems() {
    if (!cartBody) return;

    cartBody.querySelectorAll('.custom-cart-drawer__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var action = btn.getAttribute('data-action');
        var qtyEl = btn.parentElement.querySelector('.custom-cart-drawer__qty-num');
        var qty = parseInt(qtyEl.textContent, 10);

        if (action === 'plus') {
          updateItemQty(key, qty + 1);
        } else if (action === 'minus') {
          if (qty <= 1) {
            removeItem(key);
          } else {
            updateItemQty(key, qty - 1);
          }
        }
      });
    });

    cartBody.querySelectorAll('.custom-cart-drawer__item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        removeItem(key);
      });
    });
  }

  function bindRecCarousel() {
    var track = document.getElementById('cart-rec-track');

    if (!track || !cartBody) return;

    var cards = track.querySelectorAll('.custom-cart-drawer__rec-card');
    var total = cards.length;
    var current = 0;
    var visible = 2;

    function updateTrack() {
      var outerW = track.parentElement.offsetWidth;
      var cardW = (outerW - 16) / visible;

      track.style.transform = 'translateX(-' + (current * (cardW + 16)) + 'px)';
    }

    var prevBtn = cartBody.querySelector('.custom-cart-drawer__rec-prev');
    var nextBtn = cartBody.querySelector('.custom-cart-drawer__rec-next');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        current = Math.max(0, current - 1);
        updateTrack();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        current = Math.min(total - visible, current + 1);
        updateTrack();
      });
    }

    track.querySelectorAll('.custom-cart-drawer__rec-add').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = btn.getAttribute('data-variant-id');

        if (!vid) return;

        btn.disabled = true;
        btn.textContent = '...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: parseInt(vid, 10),
            quantity: 1
          })
        }).then(function () {
          loadCartAndRender();
        });
      });
    });
  }

  if (cartTrigger) {
    cartTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      openCartDrawer();
    });
  }

  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);

  /* ============================================
     加购后自动弹出购物车抽屉
  ============================================ */
  document.addEventListener('cart:refresh', function () {
    openCartDrawer();
  });

  document.addEventListener('cart:updated', function () {
    openCartDrawer();
  });

  var _origFetch = window.fetch;

  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var isAddToCart = url.indexOf('/cart/add') !== -1;

    return _origFetch.apply(this, arguments).then(function (response) {
      if (isAddToCart && response.ok) {
        var cloned = response.clone();

        cloned.json().then(function () {
          setTimeout(function () {
            openCartDrawer();
          }, 100);
        }).catch(function () {});
      }

      return response;
    });
  };

  var _origOpen = XMLHttpRequest.prototype.open;
  var _origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._cartAddUrl = url;
    return _origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var self = this;

    if (self._cartAddUrl && self._cartAddUrl.indexOf('/cart/add') !== -1) {
      self.addEventListener('load', function () {
        if (self.status >= 200 && self.status < 300) {
          setTimeout(function () {
            openCartDrawer();
          }, 100);
        }
      });
    }

    return _origSend.apply(this, arguments);
  };

  /* ============================================
     全局 Escape 键
  ============================================ */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;

    closeSearch();
    closeGiveModal();
    closeCartDrawer();
    closeMobileDrawer();
  });
})();
